/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ConversationListUpdatedPayloadSideEffectType =
  (typeof ConversationListUpdatedPayloadSideEffectType)[keyof typeof ConversationListUpdatedPayloadSideEffectType];

export const ConversationListUpdatedPayloadSideEffectType = {
  conversation_list_updated: "conversation_list_updated",
} as const;
